module.exports = __webpack_public_path__ + "static/media/headerLogo.a0d96a67.png";